import { Component, OnInit } from '@angular/core';
import { UpdateRateService } from '../../services/update-rate/update-rate.service';
import { UpdateRateResponse, Rate } from '../../types/common';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-update-rate',
  templateUrl: './update-rate.component.html',
  styleUrls: ['./update-rate.component.scss']
})
export class UpdateRateComponent implements OnInit {

  updateRateObj: UpdateRateResponse = {} as UpdateRateResponse;
  rates: Rate[] = [];
  filteredOldRates: Rate[] = [];
  filteredNewRates: Rate[] = [];
  oldRate: Rate | null = null;
  newRate: Rate | null = null;
  loaded = false;

  formErrors = '';
  formNotice = '';
  formSubmitted = false;

  constructor(
    private updateRateService: UpdateRateService,
    private messageService: MessageService
  ) { }

  ngOnInit(): void {
    this.updateRateService.getUpdateRate().subscribe({
      next: (apiObj) => {
        this.updateRateObj = apiObj as UpdateRateResponse;

        // First element will always be empty
        this.rates = [{
          name: '',
          code: ''
        }];

        // Loop over all the rates available and change format for dropdown list
        this.updateRateObj.data.descriptions.forEach(description => {
          this.rates.push({
            name: description.description,
            code: description.code
          });
        });

        // Alphabetize rates by name
        this.rates.sort((a, b) => a.name.localeCompare(b.name));

        // Indicate the template should refresh
        this.loaded = true;
      },
      error: (error) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load rate data. Please try again.'
        });
        console.error('Error loading update rate data:', error);
      }
    });
  }

  updateRate(): void {
    // Clear previous form messages
    this.formNotice = '';
    this.formErrors = '';

    if (this.formSubmitted) {
      this.formErrors = 'The rate change has already been submitted.';
      return;
    }

    if (this.updateRateObj.data.number_of_waiting_updates > 0) {
      this.formErrors = 'Updates cannot be submitted while rates are being set. Please wait ' +
        'for the previous changes to complete and then try again.';
      return;
    }

    if (!this.oldRate || !this.newRate || this.oldRate.code === '' || this.newRate.code === '') {
      this.formErrors = 'Cannot submit. You must supply an old rate and a new rate.';
      return;
    }

    this.updateRateService.postUpdateRate(
      this.oldRate.code,
      this.newRate.code,
      this.updateRateObj.data.locationID
    ).subscribe({
      next: (response) => {
        this.formErrors = '';
        this.formNotice = 'Updates posted, please allow the updates to finish before making additional ' +
          'rate changes.';
        this.formSubmitted = true;

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Rate updates posted successfully.'
        });
      },
      error: (err) => {
        this.formNotice = '';
        this.formErrors = err.error?.error || 'An error occurred while submitting the rate update.';

        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: this.formErrors
        });
      }
    });
  }

  filterOldRates(event: any): void {
    const query = event.query.toLowerCase();
    this.filteredOldRates = this.rates.filter(rate =>
      rate.name.toLowerCase().includes(query)
    );
  }

  filterNewRates(event: any): void {
    const query = event.query.toLowerCase();
    this.filteredNewRates = this.rates.filter(rate =>
      rate.name.toLowerCase().includes(query)
    );
  }
}
